import Lottie from 'lottie-web'
import React, { useEffect, useRef } from 'react'

import { SiSitepoint } from "react-icons/si";
import useTitle from './../../hooks/UseTitle';

const About = () => {
  useTitle ('About')
  const container =useRef(null)
    useEffect(()=>{
        const instance = Lottie.loadAnimation({
            container:container.current,
            renderer:'svg',
          
            autoplay:true,
            animationData:require('./newScene.json')
        })
        return () => instance.destroy();
     
    },[])
  return (
    <div className='min-h-screen max-w-screen-xl mx-auto'>
       <h2 className="font-bold text-6xl  md:text-[120px] text-gray-300 opacity-[0.3] text-center animate-pulse numb">ABOUT</h2>
       <div className="text-center absolute md:top-[3%] lg:top-[8%] top-[2%] md:left-[37%] lg:left-[42%] left-[28%]">
       <h2 data-aos="fade-up" className=" font-bold text-xl md:text-4xl text-neutral">ABOUT MYSELF</h2>
       </div>
      <div>
      <div className='grid md:grid-cols-2 '>
      <div className='lg:p-14 p-5 container w-full h-full' data-aos="zoom-in"  ref={container}></div>
      <div className='m-auto'>
      <div data-aos="fade-up">
        <h1 className='text-3xl font-bold px-5 text-neutral'> Hello ! I'm Fahmida Tasmia</h1>
        <h1 className='font-bold mt-2  px-5 text-gray-400 animate-pulse'> FRONT-END Developer | MERN-STACK Developer</h1>
      </div>
      <div>
      <ul className='p-5'>
           <li className=' mb-3 flex gap-1 ' data-aos="fade-left"><span><SiSitepoint className='text-xl text-neutral'></SiSitepoint></span>
         <span className='text-justify' >  As a passionate and meticulous front-end and MERN stack web developer, I am eager to put  my coding expertise and problem-solving abilities to use.
           Whether it's tackling complex designs or ensuring timely project completion, I am fully committed to delivering top-notch results.</span>
           </li>
           <li className=' my-3 flex gap-1 '  data-aos="fade-right"><span><SiSitepoint className='text-xl text-neutral'></SiSitepoint></span>
         <span className='text-justify' >  I focus on utilizing smart and cutting-edge methods in my web development work, 
         specifically by utilizing open-source technologies & 
         I'm always eager to take on new challenges and establish professional connections.
         </span>
           </li>
           <li className=' my-3 flex gap-1 '  data-aos="fade-up"><span><SiSitepoint className='text-xl text-neutral'></SiSitepoint></span>
         <span className='text-justify' > I am looking for a company that will provide me with an enjoyable and stimulating environment where I can flourish and develop my talents. 
         I am eager to gain professional experience and build my career by working diligently in the present for a better future.
         </span>
           </li>
                         
      </ul>
     
      </div>
      {/* <div className='flex justify-center'> <Link className='btn rounded-full  p-5'>Let's talk</Link></div> */}

     
      </div>
      
      </div >
      {/* skills */}

      <div className='md:pb-24 lg:mx-0 mx-3'>
      <div className='text-center mb-8' data-aos="fade-up">
        <h1 className='animate-pulse text-lg font-bold text-gray-400  '> What Skills I Have</h1>
        <h2 className='lg:text-4xl text-2xl font-bold text-neutral tracking-wider '> My Expertise</h2>
        </div>

        <div className='p-5'></div>

        <div className='grid lg:grid-cols-2   gap-5'  >
          <div >
            <h2 className='border-l-4 border-neutral rounded pl-2 mb-4 text-2xl  font-semibold '>Tech Stack</h2>
            <div className='grid grid-cols-2 gap-5' >
            <div style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} data-aos="zoom-in-up" className="hover:scale-110 duration-1000 ease-in-out card cursor-pointer  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-sm shadow-sm  text-neutral-content">
            <div className="card-body  text-center md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl">Frontend</h2>
             <div className=' '>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>HTML</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>JavaScript</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>React.js</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Redux</p>
             </div>
            </div>
          </div>
          {/* cards2s */}
          <div style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} data-aos="zoom-in-up" className="hover:scale-110 duration-1000 ease-in-out card cursor-pointer  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-sm shadow-sm  text-neutral-content">
          <div className="card-body  text-center md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl">Backend</h2>
             <div className=' '>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Node.js</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint> Express.js</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>MongoDB</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Mongoose</p>
             </div>
            </div>
          </div>
            </div>
          </div>
          {/* Design & Tools */}
          <div>
            <h2 className='border-l-4 border-neutral rounded pl-2 mb-4 text-2xl  font-semibold '>Design & Tools</h2>
            <div className='grid grid-cols-2 gap-5'>
            <div style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} data-aos="zoom-in-up" className="hover:scale-110 duration-1000 ease-in-out card cursor-pointer  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-sm shadow-sm  text-neutral-content">
            <div className="card-body  text-center md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl">Design</h2>
             <div className='hidden md:block '>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>CSS</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral '></SiSitepoint> Tailwind | Bootstrap</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>DaisyUi</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Material-ui | React Bootstrap </p>
              
             </div>
             {/* smm */}
             <div className='block md:hidden'>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>CSS</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral '></SiSitepoint> Tailwind </p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral '></SiSitepoint> Bootstrap</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>DaisyUi</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Material-ui </p>
           
              
             </div>
            </div>
          </div>
          {/* cards2s */}
          <div style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} data-aos="zoom-in-up" className="hover:scale-110 duration-1000 ease-in-out card cursor-pointer  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-sm shadow-sm  text-neutral-content">
          <div className="card-body  text-center md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl">Tools</h2>
             <div className=' hidden md:block'>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>VS code</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint> Git & GitHub</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Firebase</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Vercel |  Netlify  </p>
            
             </div>
             {/* smm */}
             <div className='block md:hidden'>
             <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>VS code</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>GitHub & Git</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Firebase</p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint>Vercel </p>
              <p className='flex gap-1 mb-2'><SiSitepoint className='text-lg text-neutral'></SiSitepoint> Netlify  </p>
           
              
             </div>
            </div>
          </div>
            </div>
          </div>
          {/* end desigsn and tools */}
        </div>

        <div className='py-10 md:visible invisible'></div>
      </div>

      {/* end skillss */}
      </div>
     
    </div>
  )
}

export default About